<template>
  <VisionHeading
    v-if="title.text"
    :tag="tag"
    :size="size"
    :colour-style="style"
  >
    {{ title.text }}
  </VisionHeading>
</template>

<script setup lang="ts">
type TextSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type Tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type Style = 'colour' | 'gradient'

interface Title {
  text: string | undefined,
  textSize: TextSize,
  tag: Tag,
  style: Style
}

interface TitleBlockProps {
  title: Title
}

const props = withDefaults(defineProps<TitleBlockProps>(), {
  title: () => ({
    text: '',
    textSize: 'h1',
    tag: 'h1',
    style: 'colour'
  })
})

const tag = computed(() => {
  return props.title?.tag || 'h2'
})

const size = computed(() => {
  return props.title?.textSize || 'h2'
})

const style = computed(() => {
  return props.title?.style || 'colour'
})
</script>